export default __webpack_public_path__ + "static/media/wwe-logo.6b99e59f.png";